import { tagsList } from "constants/tags";

const initialState = {
  tagsList: {},
};

const tags = (state = initialState, action) => {
  switch (action.type) {
    case tagsList:
      return { ...state, tagsList: action.payload };

    default:
      return state;
  }
};

export default tags;